module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/apis/kinesis-video-signaling-2019-12-04.paginators.json
// module id = 592
// module chunks = 0